import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "login__title" }, "HCPet Kasse", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Logg inn", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/MicrosoftLoginButton.svg",
  alt: "Login with microsoft",
  style: {"width":"100%"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Card, {
      tag: "form",
      class: "login__dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_Messages, { class: "my-2" })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            style: {"width":"100%"},
            type: "a",
            empty: true,
            href: _ctx.route('microsoft.redirect')
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _: 1
    })
  ]))
}